import type { ButtonProps } from "@v1/components/designSystem/button/Button";
import type { ButtonSize } from "@v1/components/designSystem/button/button-shared";

import * as React from "react";

import { successToast } from "@v1/components/designSystem/alert/Toast";
import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { useCurrentWorkspaceContext } from "@v2/contexts/WorkspaceDashboardContext";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";

import { useExperimentCreate } from "../tabs/hooks/useExperimentCreate";

type CreateExperimentButtonProps = {
  size?: ButtonSize;
};

export const CreateExperimentButton: React.FC<CreateExperimentButtonProps> = ({
  size = "base",
}) => {
  const commonProps: ButtonProps = {
    size: "base",
    variant: "primary",
  };

  const { workspaceId, isLoading: isWorkspaceLoading } =
    useCurrentWorkspaceContext();

  const projectId = useCurrentProjectId();

  const { createExperiment, isCreatingExperiment } = useExperimentCreate({
    workspaceId: workspaceId ?? undefined,
    projectId,
  });

  const handleCreateNewExperiment = async () => {
    await createExperiment({
      location: "experiment_list_tab",
      onExperimentCreateSuccess: () => {
        successToast("Test Created", "");
      },
    });
  };

  return (
    <DeprecatedButton
      {...commonProps}
      size={size}
      onClick={() => void handleCreateNewExperiment()}
      isLoading={isCreatingExperiment || isWorkspaceLoading}
    >
      Create New A/B Test
    </DeprecatedButton>
  );
};
